import { useEffect, useState } from 'react';
import { Button, Result, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { routesPath } from '../../common/constants/routesPath';
import { exchangeHandoffCode } from '../../services/impersonationService';
import {
    IMPERSONATION_TAB,
    USERS_PAGE_PATH,
    startImpersonationTab,
    takeHandoffCode,
} from '../../services/impersonationSession';

/**
 * /impersonate (#790): redeems the one-time code that index.js took from the URL fragment, stores the session in
 * this tab only, and reloads into the impersonated user's app. A failed exchange never falls back to sign-in.
 */
export default function ImpersonateHandoff() {
    const { t } = useTranslation('impersonation');
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const code = takeHandoffCode();
        if (!code) {
            setFailed(true);
            return;
        }

        exchangeHandoffCode(code)
            .then(result => {
                startImpersonationTab(result);
                window.location.replace(routesPath.ROOT.JOBS);
            })
            .catch(() => setFailed(true));
    }, []);

    const backToUsers = () => {
        window.sessionStorage.removeItem(IMPERSONATION_TAB);
        window.location.replace(USERS_PAGE_PATH);
    };

    if (failed) {
        return (
            <Result
                status="warning"
                title={t('handoff.invalid.title')}
                subTitle={t('handoff.invalid.description')}
                extra={
                    <Button type="primary" onClick={backToUsers}>
                        {t('handoff.backToUsers')}
                    </Button>
                }
            />
        );
    }

    return <Result icon={<Spin size="large" />} title={t('handoff.opening')} />;
}
